// extracted by mini-css-extract-plugin
export var arrows = "_2l-5";
export var decrementer = "_2l-9";
export var disabled = "_2l-3";
export var error = "_2l-1";
export var hiddenText = "_2l-a";
export var incrementer = "_2l-8";
export var input = "_2l-7";
export var inputWrapper = "_2l-0";
export var leadingIcon = "_2l-b";
export var readonly = "_2l-2";
export var regular = "_2l-6";
export var small = "_2l-4";